import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import './ContractsPage.css';

export default function ContractsPage() {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading]     = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/contracts').then(data => { setContracts(data); setLoading(false); });
  }, []);

  const statusBadge = s => <span className={`badge badge-${s.toLowerCase()}`}>{s}</span>;

  return (
    <div className="contracts-page">
      <div className="page-header">
        <h2>Contracts</h2>
        <div className="header-actions">
          <button className="btn-secondary" onClick={() => navigate('/contracts/templates')}>Templates</button>
          <button className="btn-primary"   onClick={() => navigate('/contracts/new')}>+ New Contract</button>
        </div>
      </div>

      {loading ? <div className="loading">Loading…</div> : contracts.length === 0 ? (
        <div className="empty-state">No contracts yet. Create a template first, then generate a contract.</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr><th>Title</th><th>Client</th><th>Status</th><th>Signed</th><th>Created</th></tr>
          </thead>
          <tbody>
            {contracts.map(c => (
              <tr key={c.id} className="clickable-row" onClick={() => navigate(`/contracts/${c.id}`)}>
                <td className="name-cell">{c.title}</td>
                <td>{c.clientName}</td>
                <td>{statusBadge(c.status)}</td>
                <td>{c.signedAt ? new Date(c.signedAt).toLocaleDateString() : <span className="muted">—</span>}</td>
                <td>{new Date(c.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
